import { storageHelper } from '@spo/logic';
import { useEffect } from 'react';
import { v4 } from 'uuid';
import { buildQueryParameterUrl } from '../../utils/url';

export const signIn = (state: string) => {
  storageHelper.setItem('is_fetching_token', 'true');
  const redirectUri = `${window.location.origin}/personal-offer/authentication`;
  const url = `/api/user/login?${buildQueryParameterUrl({
    redirectUri,
    state,
  })}`;
  window.location.replace(url);
};

export const SignInAndRedirect = () => {
  const uuid = v4();

  useEffect(() => {
    signIn(uuid);
  }, []);

  return (
    <p data-testid="sign-in-and-redirect">
      You will be redirected to the authentication page...
    </p>
  );
};

export default SignInAndRedirect;
